jQuery(function() {
  
  var $ = jQuery;
  
  function testScroll(ev){
	    if(window.pageYOffset>150){
			$(".wide-header-logo").fadeIn();
			//$("#back-to-top").fadeIn();
		} else {
			$(".wide-header-logo").fadeOut();
			//$("#back-to-top").fadeOut();
		}
	}

	window.onscroll=testScroll;
  
  var ptl = $(".page-title h1").text().length;
  console.log("ptl:" + ptl);
  
  if (ptl > 18) {
     $(".page-title h1").css("font-size", "2.4em");
  }

  $(".header-nav .search").on("click", function() {
    if (!$(".mobile-search").hasClass("visible")) {
      $(".mobile-search").show().addClass("visible");
    } else {
      $(".mobile-search").hide().removeClass("visible");
    }
    
  })

  $(".mobile-search-cancel").on("click", function() {
    $(".mobile-search").hide().removeClass("visible");
    return false;
  });
  
});